// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container Styling */
.sched-booking-calendar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--clr-primary-7);
  padding: 2rem;
  animation: fadeIn 0.5s ease-in-out;
}

.sched-booking-calendar-content {
  background-color: var(--clr-white);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-3);
  padding: 2rem;
  width: 100%;
  max-width: 90rem;
  transition: var(--transition);
}

/* Redirection Button Styling */
.sched-navigation {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
}

.sched-back-button {
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: var(--borderRadius);
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.sched-back-button:hover {
  background-color: var(--clr-primary-4);
  transform: translateY(-2px);
}

/* Selected Info Section Styling */
.sched-selected-info {
  margin-bottom: 1.5rem;
  font-size: 1rem;
  color: var(--clr-grey-700);
}

.sched-selected-info p {
  margin: 0.5rem 0;
}

.sched-selected-info strong {
  color: var(--clr-primary-5);
}

/* Calendar Styling */
h2 {
  font-size: 2rem;
  color: var(--clr-primary-5);
  margin-bottom: 2rem;
  text-align: center;
}

.sched-booking-calendar-content .rbc-calendar {
  border: 1px solid var(--clr-primary-6);
  border-radius: var(--borderRadius);
  overflow: hidden;
  transition: var(--transition);
}

.sched-booking-calendar-content .rbc-header {
  background-color: var(--clr-primary-9);
  color: var(--clr-primary-1);
  padding: 0.5rem;
  font-size: 1rem;
  border-bottom: 1px solid var(--clr-primary-5);
  transition: background-color 0.3s ease;
}

.sched-booking-calendar-content .rbc-header:hover {
  background-color: var(--clr-primary-7);
}

.sched-booking-calendar-content .rbc-date-cell {
  font-size: 1rem;
  color: var(--clr-primary-2);
  transition: color 0.3s ease;
}

.sched-booking-calendar-content .rbc-date-cell:hover {
  color: var(--clr-primary-9);
}

.sched-booking-calendar-content .rbc-event {
  background-color: var(--clr-primary-5);
  border-radius: var(--borderRadius);
  color: var(--clr-white);
  padding: 0.2rem;
  text-align: center;
  transition: background-color 0.3s ease;
  animation: bounceIn 0.5s ease-in-out; 
}

.sched-booking-calendar-content .rbc-event:hover {
  background-color: var(--clr-primary-3);
}

.sched-booking-calendar-content .rbc-today {
  background-color: var(--clr-primary-10);
  border: 1px solid var(--clr-primary-5);
}

.sched-booking-calendar-content .rbc-day-slot .rbc-time-slot {
  border-top: 1px solid var(--clr-grey-300);
}

.sched-booking-calendar-content .rbc-selected-cell {
  background-color: var(--clr-primary-6);
}

.sched-booking-calendar-content .rbc-time-view .rbc-allday-cell {
  border-bottom: 1px solid var(--clr-grey-200);
}

/* Past event styling */
.sched-booking-calendar-content .rbc-event.is-past {
  background-color: var(--clr-grey-300);
  color: var(--clr-grey-600);
  pointer-events: none; /* Disable interaction */
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Styling */
@media (max-width: 768px) {
  .sched-booking-calendar-container {
    padding: 1rem;
  }

  .sched-booking-calendar-content {
    padding: 1rem;
    max-width: 100%;
  }

  .sched-navigation {
    justify-content: center;
    margin-bottom: 1rem;
  }

  .sched-back-button {
    padding: 0.6rem 1rem;
    font-size: 0.875rem;
  }

  .sched-selected-info {
    font-size: 0.9rem;
  }

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .sched-booking-calendar-content .rbc-calendar {
    border: 1px solid var(--clr-primary-6);
    border-radius: var(--borderRadius);
    overflow: hidden;
    transition: var(--transition);
  }

  .sched-booking-calendar-content .rbc-header {
    font-size: 0.8rem;
    padding: 0.3rem;
  }

  .sched-booking-calendar-content .rbc-date-cell {
    font-size: 0.8rem;
  }

  .sched-booking-calendar-content .rbc-event {
    font-size: 0.7rem;
    padding: 0.1rem;
  }

  .sched-booking-calendar-content .rbc-today {
    border-width: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/BookingCalendarView.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB,EAAE,wBAAwB;AAChD;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,kCAAkC;IAClC,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Main Container Styling */\n.sched-booking-calendar-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: var(--clr-primary-7);\n  padding: 2rem;\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.sched-booking-calendar-content {\n  background-color: var(--clr-white);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-3);\n  padding: 2rem;\n  width: 100%;\n  max-width: 90rem;\n  transition: var(--transition);\n}\n\n/* Redirection Button Styling */\n.sched-navigation {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1.5rem;\n}\n\n.sched-back-button {\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: var(--borderRadius);\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.sched-back-button:hover {\n  background-color: var(--clr-primary-4);\n  transform: translateY(-2px);\n}\n\n/* Selected Info Section Styling */\n.sched-selected-info {\n  margin-bottom: 1.5rem;\n  font-size: 1rem;\n  color: var(--clr-grey-700);\n}\n\n.sched-selected-info p {\n  margin: 0.5rem 0;\n}\n\n.sched-selected-info strong {\n  color: var(--clr-primary-5);\n}\n\n/* Calendar Styling */\nh2 {\n  font-size: 2rem;\n  color: var(--clr-primary-5);\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.sched-booking-calendar-content .rbc-calendar {\n  border: 1px solid var(--clr-primary-6);\n  border-radius: var(--borderRadius);\n  overflow: hidden;\n  transition: var(--transition);\n}\n\n.sched-booking-calendar-content .rbc-header {\n  background-color: var(--clr-primary-9);\n  color: var(--clr-primary-1);\n  padding: 0.5rem;\n  font-size: 1rem;\n  border-bottom: 1px solid var(--clr-primary-5);\n  transition: background-color 0.3s ease;\n}\n\n.sched-booking-calendar-content .rbc-header:hover {\n  background-color: var(--clr-primary-7);\n}\n\n.sched-booking-calendar-content .rbc-date-cell {\n  font-size: 1rem;\n  color: var(--clr-primary-2);\n  transition: color 0.3s ease;\n}\n\n.sched-booking-calendar-content .rbc-date-cell:hover {\n  color: var(--clr-primary-9);\n}\n\n.sched-booking-calendar-content .rbc-event {\n  background-color: var(--clr-primary-5);\n  border-radius: var(--borderRadius);\n  color: var(--clr-white);\n  padding: 0.2rem;\n  text-align: center;\n  transition: background-color 0.3s ease;\n  animation: bounceIn 0.5s ease-in-out; \n}\n\n.sched-booking-calendar-content .rbc-event:hover {\n  background-color: var(--clr-primary-3);\n}\n\n.sched-booking-calendar-content .rbc-today {\n  background-color: var(--clr-primary-10);\n  border: 1px solid var(--clr-primary-5);\n}\n\n.sched-booking-calendar-content .rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid var(--clr-grey-300);\n}\n\n.sched-booking-calendar-content .rbc-selected-cell {\n  background-color: var(--clr-primary-6);\n}\n\n.sched-booking-calendar-content .rbc-time-view .rbc-allday-cell {\n  border-bottom: 1px solid var(--clr-grey-200);\n}\n\n/* Past event styling */\n.sched-booking-calendar-content .rbc-event.is-past {\n  background-color: var(--clr-grey-300);\n  color: var(--clr-grey-600);\n  pointer-events: none; /* Disable interaction */\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n  50% {\n    opacity: 0.9;\n    transform: scale(1.1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n  .sched-booking-calendar-container {\n    padding: 1rem;\n  }\n\n  .sched-booking-calendar-content {\n    padding: 1rem;\n    max-width: 100%;\n  }\n\n  .sched-navigation {\n    justify-content: center;\n    margin-bottom: 1rem;\n  }\n\n  .sched-back-button {\n    padding: 0.6rem 1rem;\n    font-size: 0.875rem;\n  }\n\n  .sched-selected-info {\n    font-size: 0.9rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  .sched-booking-calendar-content .rbc-calendar {\n    border: 1px solid var(--clr-primary-6);\n    border-radius: var(--borderRadius);\n    overflow: hidden;\n    transition: var(--transition);\n  }\n\n  .sched-booking-calendar-content .rbc-header {\n    font-size: 0.8rem;\n    padding: 0.3rem;\n  }\n\n  .sched-booking-calendar-content .rbc-date-cell {\n    font-size: 0.8rem;\n  }\n\n  .sched-booking-calendar-content .rbc-event {\n    font-size: 0.7rem;\n    padding: 0.1rem;\n  }\n\n  .sched-booking-calendar-content .rbc-today {\n    border-width: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
